import React from "react";

interface LinkedInIconProps {
  className?: string;
  fill?: string;
  height?: number;
  width?: number;
}

const LinkedInIcon = ({
  className,
  fill,
  height = 30,
  width = 30
}: LinkedInIconProps) => (
  <svg width={width} height={height} viewBox="0 0 30 30" className={className}>
    <path
      fill={fill}
      d="M28.734 0H1.266A1.26 1.26 0 000 1.266V28.78C0 29.438.563 30 1.266 30H28.78a1.26 1.26 0 001.266-1.266V1.266C30 .562 29.437 0 28.734 0zM8.906 25.547H4.453V11.25h4.453v14.297zM6.656 9.28a2.601 2.601 0 01-2.578-2.578 2.601 2.601 0 012.578-2.578 2.601 2.601 0 012.578 2.578A2.542 2.542 0 016.656 9.28zm18.89 16.266h-4.452v-6.938c0-1.64-.047-3.797-2.297-3.797-2.297 0-2.672 1.829-2.672 3.657v7.078h-4.453V11.25h4.265v1.969h.047c.61-1.125 2.063-2.297 4.22-2.297 4.5 0 5.343 2.953 5.343 6.797v7.828z"
    />
  </svg>
);

export default LinkedInIcon;
